import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

export const useGetCreditReport = (
  startDate: string,
  endDate: string,
  customer: string | undefined,
  status: string,
  fetchReport: boolean
) => {
  const token = getToken();

  return useQuery({
    queryKey: [
      "creditReport",
      startDate,
      endDate,
      customer,
      status,
      fetchReport,
    ],
    queryFn: async () => {
      if (!token || !startDate || !endDate) return;

      const params: Record<string, string> = { startDate, endDate };
      if (customer) params.customer = customer;
      if (status) params.status = status;

      const response = await axiosInstance.get("reports/credits", {
        headers: { Authorization: `Bearer ${token}` },
        params,
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      const fileNameParts = [`Betty_Credit_Report_${startDate}_to_${endDate}`];
      if (customer) fileNameParts.push(`Customer_${customer}`);
      if (status) fileNameParts.push(`Status_${status}`);
      const fileName = `${fileNameParts.join("_")}.xlsx`;

      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return { success: true };
    },
    enabled: fetchReport,
  });
};
